import { useEffect, useRef } from 'react';

export const useDisplayWakeLock = () => {
  const wakeLockRef = useRef(null);

  useEffect(() => {
    const requestWakeLock = async () => {
      try {
        if ('wakeLock' in navigator) {
          wakeLockRef.current = await navigator.wakeLock.request('screen');
          wakeLockRef.current.addEventListener('release', () => {
            console.log('Screen Wake Lock released');
          });
          console.log('Screen Wake Lock acquired');
        }
      } catch (err) {
        console.warn(`${err.name}, ${err.message}`);
      }
    };

    // Request initial wake lock
    requestWakeLock();

    // Re-request wake lock when visibility changes (e.g. returning to tab)
    const handleVisibilityChange = () => {
      if (wakeLockRef.current !== null && document.visibilityState === 'visible') {
        requestWakeLock();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      if (wakeLockRef.current) {
        wakeLockRef.current.release()
          .then(() => {
            wakeLockRef.current = null;
          })
          .catch((err) => {
            console.warn(`Error releasing wake lock: ${err.name}, ${err.message}`);
          });
      }
    };
  }, []);
};
